/**
 * Labstep
 */

import { PostFilter } from 'labstep-web/services/postFilter';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';

export const PostFilterResource = new PostFilter(
  [['guid', PostFilterComparison.eq]],
  'resource',
);
